<div *ngIf="viewType === 'welcome'">
    <div class='col-md-12'>
        <h1>{{LOCALIZATION.preContent1Header}}</h1>
        <ul>
            <li>{{LOCALIZATION.preContent1List1}} </li>
            <li>{{LOCALIZATION.preContent1List2}} </li>
            <li>{{LOCALIZATION.preContent1List3}} </li>
            <li>{{LOCALIZATION.preContent1List4}} </li>
        </ul>
        <h1>{{LOCALIZATION.preContent2Header}} </h1>
        <ul>
            <li>{{LOCALIZATION.preContent2List1}} </li>
            <li>{{LOCALIZATION.preContent2List2}} </li>
            <li>{{LOCALIZATION.preContent2List3}} </li>
        </ul>
		<h1>{{LOCALIZATION.preContent3Header}} </h1>
        <ul>
            <li>{{LOCALIZATION.preContent3List1}} </li>
            <li>{{LOCALIZATION.preContent3List2}} </li>
            <li>{{LOCALIZATION.preContent3List3}} </li>
        </ul>        
    </div>  
</div>

<div *ngIf="viewType === 'search'">
	<div class='col-md-12'>
        <h3>{{LOCALIZATION.emptyContent1Header}}</h3>
        <ul>
            <li>{{LOCALIZATION.emptyContent1List1}} </li>
            <li>{{LOCALIZATION.emptyContent1List2}} </li>
            <li>{{LOCALIZATION.emptyContent1List3}} </li>
            <li>{{LOCALIZATION.emptyContent1List4}} </li>
        </ul>
    </div>  
</div>

<div *ngIf="viewType === 'browse'">
	<div class='col-md-12'>
        <h3>{{LOCALIZATION.emptyBrowseContent1Header}}</h3>
    </div>
</div>